import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { changeNickname } from '@/assets/js/attendUser.js';
import { handleLocalStorage } from '@/assets/js/utils';
export default {
  props: {
    anywherePopShow: Boolean,
    anywhereSetting: Boolean,
    pipVolume: [String, Number],
    shows: Boolean,
    devicePlatform: [String, Number],
    deviceType: [String, Number],
    degreePipSelf: [String, Number],
    degreeHostSelf: [String, Number],
    degreeHost: {
      type: [String, Number],
      default: 0
    },
    nickName: [String, Number],
    tagName: String,
    organization: String,
    fullScreenInfo: Boolean,
    showChat: {
      type: Boolean,
      default: false
    },
    rtcLoaded: {
      type: Boolean,
      default: false
    },
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    shareLayOut: {
      // share全屏的样式来源于父组件自定义，不走该组件的逻辑
      type: String,
      default: () => {
        return '';
      }
    },
    editNickName: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    isAudioLevel: {
      type: Boolean,
      default() {
        return true;
      }
    },
    lockName: {
      type: Boolean,
      default() {
        return false;
      }
    },
    singChannel: {
      type: Object,
      default: function () {
        return {};
      }
    },
    title: {
      type: [String, Number],
      default: null
    },
    isallScrren: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      validator: function (value) {
        if (['success', 'danger'].includes(value)) {
          return value;
        }
        return '';
      }
    },
    needStartVoip: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    volume: {
      type: Object,
      default: function () {
        return {
          level: 0
        };
      }
    },
    outputRtilCode: {
      type: [String, Number],
      default: ''
    },
    muteVideo: {
      // 是否默认关闭摄像头
      type: Boolean,
      default: true
    },
    muteAudio: {
      // 是否默认静音
      type: Boolean,
      default: true
    },
    blockVideo: {
      // 是否默认关闭摄像头
      type: Boolean,
      default: false
    },
    blockAudio: {
      // 是否默认静音
      type: Boolean,
      default: false
    },
    controlMute: {
      // 用于单独控制静音
      default: ''
    },
    notShowPraviteBg: {
      // 直接控制不显示私聊背景优先级最大
      type: Boolean,
      default: false
    },
    asRoleList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    operateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    buttonStatus: {
      default: ''
    },
    showMuteIcons: {
      type: Boolean,
      default: true
    },
    currentRole: {
      type: String,
      default: ''
    },
    nameColor: {
      type: String,
      default: ''
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showOperateBox: {
      type: Boolean,
      default: true
    },
    selectRid: {
      type: String,
      default: ''
    },
    sourceId: {
      type: String,
      default: ''
    },
    outputSourceType: {
      type: String,
      default: () => {
        return '';
      }
    },
    rtc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    remoteNetWorks: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showPipCursorPointer: {
      type: Boolean,
      default: false
    },
    useOldFullScreen: {
      type: Boolean,
      default: false
    },
    hearSelf: {
      type: Boolean,
      default: false
    },
    sourceType: {
      type: String,
      default: 'Web'
    },
    rtilCodeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    leftRightRtilCode: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      setTag: '',
      fullRotate: false,
      receiveDegree: '',
      isSetAnywhereRotate: false,
      isSetHostPipRotate: false,
      showAudio: true,
      showEditInput: false,
      name: '',
      redTip: '',
      nameAjax: false,
      showVideoBottom: false,
      privateInfoForVolume: {},
      lastAudioOperationTime: 0,
      // 用来显示快速点击的问题
      lastVideoOperationTime: 0,
      // 用来显示快速点击的问题
      initVideoPopup: true,
      initAudioPopup: true,
      loadVideoTrack: false,
      remoteNetWorkIconColor: '',
      showDiv: true,
      fullScreen: false,
      sourceMute: false,
      needSpecialIconList: ['4-9', '5-4', '5-7', '6-7', '7-7', '4-8', '8-8'],
      isMouseMove: false,
      controlOperateTimer: null,
      audioMatrixIconTips: '',
      level: 0,
      hasLeftDisplay: false,
      showUpinMainwindow: false,
      testAudioTrack: {} // 测试代码
    };
  },

  created() {
    Bus.$on('subscribeAudioControl', val => {
      if (val == 1) {
        this.showAudio = true;
      } else if (val == 2) {
        this.showAudio = false;
      } else if (val == 0) {
        this.showAudio = true;
      }
    });
    Bus.$on('changeMainwindowFullScreen', data => {
      // 目前只有 common party 与会者才有的行为，当有一个被放大，其他的就要被缩小
      const {
        value,
        id
      } = data;
      if (id == this.singChannel.id) {
        this.hasLeftDisplay = value;
      }
    });
    window.addEventListener('resize', this.dealVideoWidth);
    Bus.$on('intercom', v => {
      const {
        rtilCode,
        receiveRtilCode,
        value
      } = v;
      if (value !== 'true') {
        // 根据最新逻辑只需要恢复发起私聊人的声音就可以
        if (rtilCode != this.userInfo.rtilCode && receiveRtilCode != this.userInfo.rtilCode) {
          if (rtilCode == this.singChannel.id && !this.State.startPrivateInfo[rtilCode]) {
            // 对于正在私聊的人的视频要静音不能被听见
            if (this.singChannel.audioTrack && !this.isMute) {
              if (this.rtc && this.rtc.play) {
                this.rtc.play(this.singChannel.audioTrack, '', {
                  type: 'audio'
                });
              }
            }
          }
        }
      } else {
        // 如果是和自己聊要恢复发起者的声音
        if (receiveRtilCode == this.userInfo.rtilCode && this.singChannel.audioTrack && !this.isMute) {
          if (rtilCode == this.singChannel.id && this.rtc && this.rtc.play) {
            this.rtc.play(this.singChannel.audioTrack, '', {
              type: 'audio'
            });
          }
        }
      }
    });
    Bus.$on('cancelPrivateConversation', v => {
      const {
        rtilCode,
        crewRtilCode
      } = v;
      // 恢复视频声音
      if (this.userInfo.rtilCode != rtilCode && this.userInfo.rtilCode != crewRtilCode) {
        if (this.singChannel.id == rtilCode || this.singChannel.id == crewRtilCode) {
          // 对于正在私聊的人的视频要静音不能被听见
          if (this.singChannel.audioTrack && !this.isMute) {
            if (this.rtc && this.rtc.play) {
              this.rtc.play(this.singChannel.audioTrack, '', {
                type: 'audio'
              });
            }
          }
        }
      }
    });
    Bus.$on('startVoIP', val => {
      if (val.rtilCode && val.rtilCode == this.singChannel.id && this.$refs.voip) {
        this.$refs.voip.changeSourceId(val);
        if (val.rtilCode == this.userInfo.rtilCode) {
          this.Webrtc.init(this.State.config.urlInfo.webRtc, {
            loginName: val.sourceId
          }, () => {
            var _this$$refs$voip;
            (_this$$refs$voip = this.$refs.voip) === null || _this$$refs$voip === void 0 ? void 0 : _this$$refs$voip.startVoIP();
          });
        } else {
          this.$refs.voip.changeVoIPStatus(1);
        }
      }
    });
    Bus.$on('stopVoIP', val => {
      if (val && val.rtilCode == this.singChannel.id && this.$refs.voip) {
        if (val.rtilCode == this.userInfo.rtilCode) {
          var _this$Webrtc, _this$Webrtc$websocke, _this$Webrtc$websocke2;
          this.$refs.voip.stopVoIP();
          // 停掉之前的ws，因为sourceId会变
          (_this$Webrtc = this.Webrtc) === null || _this$Webrtc === void 0 ? void 0 : (_this$Webrtc$websocke = _this$Webrtc.websocket) === null || _this$Webrtc$websocke === void 0 ? void 0 : (_this$Webrtc$websocke2 = _this$Webrtc$websocke.websocket) === null || _this$Webrtc$websocke2 === void 0 ? void 0 : _this$Webrtc$websocke2.close();
        } else {
          this.$refs.voip.changeVoIPStatus(0);
        }
        this.$refs.voip.changeSourceId('');
      }
    });
  },
  computed: {
    showCommonPrivateIcon() {
      if (this.userInfo.channelMode !== 0) return false;
      let showPrivate = false;
      if (this.userInfo.owner || this.State.currentPartyInfo.coHost == 2) {
        showPrivate = true;
      } else {
        var _this$State$startPriv, _this$State$startPriv2;
        const hasPrivateWidthMe = (_this$State$startPriv = this.State.startPrivateInfo[this.singChannel.id]) === null || _this$State$startPriv === void 0 ? void 0 : _this$State$startPriv.includes(this.userInfo.rtilCode);
        const hasPrivateWidthThis = (_this$State$startPriv2 = this.State.startPrivateInfo[this.userInfo.rtilCode]) === null || _this$State$startPriv2 === void 0 ? void 0 : _this$State$startPriv2.includes(this.singChannel.id);
        if (hasPrivateWidthMe && hasPrivateWidthThis || this.State.intercom) {
          showPrivate = true;
        }
      }
      return this.singChannel.id != this.userInfo.rtilCode && !this.State.audioMatrixEnable && !this.State.pushTalkOpen && showPrivate && this.sourceType != 'T' && this.sourceType != 'R';
    },
    returnPrivateClass() {
      var _this$State$startPriv3, _this$State$startPriv4, _this$State$startPriv5, _this$State$startPriv6, _this$State$startPriv7, _this$State$startPriv8, _this$State$startPriv9, _this$State$startPriv10;
      let privateClass = 'icon-role1';
      // 双向通话的 icon 显示逻辑
      if ((_this$State$startPriv3 = this.State.startPrivateInfo[this.singChannel.id]) !== null && _this$State$startPriv3 !== void 0 && _this$State$startPriv3.length && this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode) && (_this$State$startPriv4 = this.State.startPrivateInfo[this.userInfo.rtilCode]) !== null && _this$State$startPriv4 !== void 0 && _this$State$startPriv4.length && this.State.startPrivateInfo[this.userInfo.rtilCode].includes(this.singChannel.id)) {
        privateClass = 'icon-private1 red';
      } else if ((_this$State$startPriv5 = this.State.startPrivateInfo[this.userInfo.rtilCode]) !== null && _this$State$startPriv5 !== void 0 && _this$State$startPriv5.length && this.State.startPrivateInfo[this.userInfo.rtilCode].includes(this.singChannel.id) && (!((_this$State$startPriv6 = this.State.startPrivateInfo[this.singChannel.id]) !== null && _this$State$startPriv6 !== void 0 && _this$State$startPriv6.length) || (_this$State$startPriv7 = this.State.startPrivateInfo[this.singChannel.id]) !== null && _this$State$startPriv7 !== void 0 && _this$State$startPriv7.length && !this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode))) {
        privateClass = 'icon-privateIn red';
      } else if ((_this$State$startPriv8 = this.State.startPrivateInfo[this.singChannel.id]) !== null && _this$State$startPriv8 !== void 0 && _this$State$startPriv8.length && this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode) && (!((_this$State$startPriv9 = this.State.startPrivateInfo[this.userInfo.rtilCode]) !== null && _this$State$startPriv9 !== void 0 && _this$State$startPriv9.length) || (_this$State$startPriv10 = this.State.startPrivateInfo[this.userInfo.rtilCode]) !== null && _this$State$startPriv10 !== void 0 && _this$State$startPriv10.length && !this.State.startPrivateInfo[this.userInfo.rtilCode].includes(this.singChannel.id))) {
        privateClass = 'icon-privateOut red';
      }
      return privateClass;
    },
    retrunIntercomTips() {
      var _this$State$startPriv11, _this$State$startPriv12;
      const isHostHasPrivate = (_this$State$startPriv11 = this.State.startPrivateInfo[this.userInfo.rtilCode]) === null || _this$State$startPriv11 === void 0 ? void 0 : _this$State$startPriv11.length;
      const hostHasPrivateWithThis = isHostHasPrivate ? this.State.startPrivateInfo[this.userInfo.rtilCode].includes(this.singChannel.id) : false;
      const currentHasPrivate = (_this$State$startPriv12 = this.State.startPrivateInfo[this.singChannel.id]) === null || _this$State$startPriv12 === void 0 ? void 0 : _this$State$startPriv12.length;
      const currentHasPrivateWithHost = currentHasPrivate ? this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode) : false;
      if ((!isHostHasPrivate || !hostHasPrivateWithThis) && (!currentHasPrivate || currentHasPrivateWithHost)) {
        return this.$t('commonPartyHost.turnOnIntercom') + '<br>' + ' · ' + this.$t('commonPartyHost.turnOnMessage');
      } else if (isHostHasPrivate && hostHasPrivateWithThis && (!currentHasPrivate || !currentHasPrivateWithHost)) {
        return this.$t('commonPartyHost.turnOffOneWayIntercom') + '<br>' + ' · ' + this.$t('commonPartyHost.hostTurnOffOneWay') + '<br>' + ' · ' + this.$t('commonPartyHost.outsideText');
      } else if ((!isHostHasPrivate || !hostHasPrivateWithThis) && currentHasPrivate && currentHasPrivateWithHost) {
        return this.$t('commonPartyHost.turnOnOneWayIntercom') + '<br>' + this.$t('commonPartyHost.hostTurnOnOneWay') + '<br>' + ' · ' + this.$t('commonPartyHost.outsideText1');
      } else {
        if (this.State.localSendPrivateArray.includes(this.singChannel.id)) {
          return this.$t('commonPartyHost.turnOffIntercom') + '<br>' + ' · ' + this.$t('commonPartyHost.stopBoth');
        } else {
          return this.$t('commonPartyHost.turnOffOneWayIntercom') + '<br>' + ' · ' + this.$t('commonPartyHost.hostTurnOffOneWay') + '<br>' + ' · ' + this.$t('commonPartyHost.outsideText');
        }
      }
    },
    returnPrivateStatus() {
      if (this.userInfo.channelMode === 0) {
        var _this$State$startPriv13;
        if (!this.State.intercom && !this.userInfo.owner && (_this$State$startPriv13 = this.State.startPrivateInfo[this.singChannel.id]) !== null && _this$State$startPriv13 !== void 0 && _this$State$startPriv13.length && this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showRedClass() {
      let _str = '';
      Object.keys(this.State.currentPushTalkInfo).forEach(key => {
        if (this.State.currentPushTalkInfo[key].rtilCodeList.includes(this.singChannel.id) && this.State.currentPushTalkInfo[key].talk) {
          _str = 'redColor';
        }
      });
      return _str;
    },
    isRotated() {
      return this.degreeHost === '90' || this.degreeHost === 90 || this.degreeHost === '270' || this.degreeHost === 270;
    },
    ...mapState({
      State: state => state,
      isMute: state => state.isMute,
      privateInfo: state => state.privateInfo,
      Webrtc: state => state.webrtc
    }),
    showVideoBg() {
      let flag = false;
      if (this.muteVideo || this.blockVideo) {
        flag = true;
      }
      if ((this.title == 'PGM' || this.title === 'VFB') && this.outputSourceType != 'Participant') {
        // 通过R那边推送过来的流，在离开时会mute掉video和audio，所以忽略背景显示
        flag = false;
      }
      if (this.singChannel.hasUnsubscribe) {
        flag = false;
      }
      return flag;
    },
    muteAudioIcon() {
      let flag = false;
      if (this.muteAudio || this.blockAudio) {
        flag = true;
      }
      return flag;
    },
    muteVideoIcon() {
      let flag = false;
      if (this.muteVideo || this.blockVideo) {
        flag = true;
      }
      return flag;
    },
    editTitle() {
      let flag = false;
      if (this.userInfo.managerRtils && this.userInfo.managerRtils.includes(this.userInfo.rtilCode)) {
        // host可以修改所有人
        flag = true;
      }
      if (this.singChannel.id == this.userInfo.rtilCode && this.userInfo.managerRtils && !this.userInfo.managerRtils.includes(this.userInfo.rtilCode) && !this.lockName) {
        // 与会者只能修改自己的rename，并且在party的lockName没有锁住的情况下
        flag = true;
      }
      if (!this.editNickName) flag = false;
      return flag;
    },
    isSelfAllScreen() {
      return this.isallScrren;
    },
    showPrivateBg() {
      let flag = false;
      // commonparty 页面私聊逻辑区别于其他页面
      if (this.$route.name === 'party' || this.$route.name === 'partyParticipate') {
        // 根据最新逻辑只需要静音发起私聊人的声音就可以
        const privateArray = this.State.startPrivateInfo[this.singChannel.id];
        if (privateArray && this.singChannel.id != this.userInfo.rtilCode && !privateArray.includes(this.userInfo.rtilCode)) {
          flag = true;
          // 对于正在私聊的人的视频要静音不能被听见
          if (this.singChannel.audioTrack) {
            this.singChannel.audioTrack.stop();
          }
        }
      } else {
        // 既不是发起者也不是接受者
        if (this.privateInfo.rtilCode && this.userInfo.rtilCode != this.privateInfo.rtilCode && this.userInfo.rtilCode != this.privateInfo.crewRtilCode) {
          if (this.singChannel.id == this.privateInfo.rtilCode || this.singChannel.id == this.privateInfo.crewRtilCode) {
            flag = true;
            // 对于正在私聊的人的视频要静音不能被听见
            if (this.singChannel.audioTrack) {
              this.singChannel.audioTrack.stop();
            }
          }
        }
        this.State.privateInfoByOthers.forEach(v => {
          if (this.singChannel.id == v.rtilCode || this.singChannel.id == v.crewRtilCode) {
            flag = true;
            if (this.singChannel.audioTrack) {
              this.singChannel.audioTrack.stop();
            }
          }
        });
        if (this.notShowPraviteBg) flag = false;
      }
      return flag;
    },
    showNetStatus() {
      let flag = false;
      const title = ['PGM', 'VFB', 'Me'];
      // 目前只在party页面添加
      if (!this.title || title.includes(this.title)) {
        flag = false;
      } else if (this.remoteNetWorkIconColor === 'Orange' || this.remoteNetWorkIconColor === 'Red') {
        flag = true;
      }
      return flag;
    },
    praviteEach() {
      if (!this.userInfo.rtilCode || !this.singChannel.id) return false;
      let bg = false;
      if (this.userInfo.channelMode == 0) {
        // common party name 变红逻辑改为当这个 rtilcode 有在私聊，并且私聊没有自己时，则名字变红
        if (this.singChannel.id != this.userInfo.rtilCode && this.State.startPrivateInfo[this.singChannel.id] && this.State.startPrivateInfo[this.singChannel.id].length && !this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode)) {
          bg = true;
        }
      } else {
        const {
          privateInfo,
          privateInfoByOthers
        } = this.State;
        // 互相私聊的两个人显示红色
        if (privateInfo.rtilCode == this.singChannel.id || privateInfo.crewRtilCode == this.singChannel.id) {
          bg = true;
        }
        privateInfoByOthers.forEach(v => {
          if (this.singChannel.id == v.rtilCode || this.singChannel.id == v.crewRtilCode) {
            bg = true;
          }
        });
      }
      return bg;
    },
    judgeShowVoIP() {
      if (this.title != 'PGM' && this.title != 'Share' && this.title != 'VFB' && this.selectRid && !this.selectRid.includes('fffffff') &&
      // 只有cc的R才可以voip
      this.singChannel.tid && (this.singChannel.tid.length != 16 || this.singChannel.tid.length == 16 && this.singChannel.tid.includes('PL_')) && this.singChannel.tid.length != 15) {
        return true;
      } else {
        return false;
      }
    },
    showNickName() {
      return this.State.groupLayout.layoutName === '5-4' ? this.nickName : '';
    },
    addPipClass() {
      let _str = '';
      if (this.title != 'PGM' && this.title != 'VFB' && this.title != 'Share') {
        _str = 'pip';
      }
      return _str;
    },
    audioMatrixIcon() {
      // 1. 你能听到对方对方不听你为蓝色
      // 2. 你听不到对方对方能听见你黄色
      // 3. 彼此听不见红色
      let _class = '';
      const _this = this;
      const talkToThis = !_this.State.matrixInfoUnTalkMap[_this.State.partyJoinInfo.rtilCode] || !_this.State.matrixInfoUnTalkMap[_this.State.partyJoinInfo.rtilCode].includes(this.singChannel.id) ? 1 : 0;
      const hearThis = !_this.State.matrixInfoMuteMap[_this.State.partyJoinInfo.rtilCode] || !_this.State.matrixInfoMuteMap[_this.State.partyJoinInfo.rtilCode].includes(this.singChannel.id) ? 1 : 0;
      const thisTalkToMe = !_this.State.matrixInfoUnTalkMap[_this.singChannel.id] || !_this.State.matrixInfoUnTalkMap[_this.singChannel.id].includes(_this.State.partyJoinInfo.rtilCode) ? 1 : 0;
      const thisHearMe = !_this.State.matrixInfoMuteMap[_this.singChannel.id] || !_this.State.matrixInfoMuteMap[_this.singChannel.id].includes(this.State.partyJoinInfo.rtilCode) ? 1 : 0;
      if (!this.State.audioMatrixEnable) return;
      if (JSON.stringify(this.State.startPrivateInfo) != '{}') return;
      // 彼此听不见红色
      const {
        left,
        right
      } = this.dealAudioMatrix([talkToThis, hearThis], [thisHearMe, thisTalkToMe]);
      if (!left && !right) {
        _class = 'icon-a-stateshuangxiangbutong red';
        this.audioMatrixIconTips = this.$t('setting.redAudioMatrixIcon');
      } else if (left && !right) {
        _class = 'icon-a-audioin yellow';
        this.audioMatrixIconTips = this.$t('setting.yellowAudioMatrixIcon');
      } else if (!left && right) {
        _class = 'icon-a-audioout blue';
        this.audioMatrixIconTips = this.$t('setting.blueAudioMatrixIcon');
      }
      return _class;
    },
    returnVideoClass() {
      let _str = '';
      if (this.$refs.videoTest && this.singChannel.id != this.userInfo.rtilCode) {
        this.$refs.videoTest.style = '';
      }
      if (this.showPrivateBg) {
        _str += 'private';
      }
      if (this.degreeHost == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost == 90) {
        if (this.fullRotate && this.State.isVertical) {
          this.$refs.videoTest.style = 'transform:rotate(90deg)';
          this.$nextTick(() => {
            const screenHeight = window.screen.height;
            const fullVideoHeight = this.$refs.videoTest.clientWidth;
            this.$refs.videoTest.style = `transform:rotate(90deg)scale(${screenHeight / fullVideoHeight})`;
          });
        } else {
          _str += 'rotate90';
        }
      } else if (this.degreeHost == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost == 270) {
        if (this.fullRotate && this.State.isVertical) {
          this.$refs.videoTest.style = 'transform:rotate(270deg)';
          this.$nextTick(() => {
            const screenHeight = window.screen.height;
            const fullVideoHeight = this.$refs.videoTest.clientWidth;
            this.$refs.videoTest.style = `transform:rotate(270deg)scale(${screenHeight / fullVideoHeight})`;
          });
        } else {
          _str += 'rotate270';
        }
      }
      return _str;
    },
    showTips() {
      let showIt = false;
      if (this.singChannel.id == this.userInfo.rtilCode && this.State.initCamera) {
        showIt = true;
      }
      return showIt;
    },
    returnShowShareDot() {
      return this.singChannel.shareCode == this.singChannel.id && this.userInfo.owner;
    }
  },
  methods: {
    controlLocalSharePlay(val) {
      if (!this.singChannel.videoTrack || !this.rtc) return;
      if (val) {
        const videoTrack = this.singChannel.videoTrack;
        this.rtc.play(videoTrack, {
          fit: 'contain'
        }, {
          videoBox: this.$refs.videoTest,
          type: 'video'
        }, () => {
          this.loadVideoTrack = true;
          this.$refs.videoControl && this.$refs.videoControl.calculateBoxWidth();
        });
      } else {
        this.rtc.stop(this.singChannel.videoTrack);
      }
    },
    canvasDrap(id, data) {
      const canvas = document.getElementsByClassName(id);
      if (!canvas || canvas.length == 0) return;
      if (canvas && canvas.length > 0) {
        for (let i = 0; i < canvas.length; i++) {
          const currentCanvas = canvas[i];
          const w = currentCanvas.clientWidth;
          const h = currentCanvas.clientHeight;
          const currentPercent = data;
          const ctx = currentCanvas.getContext('2d');
          currentCanvas.width = w;
          currentCanvas.height = h;
          currentCanvas.style.transform = 'rotate(180deg)';
          // 填充渐变色, fillRect 是从左上角开始 即(0,0)坐标开始.
          // 因此注意,canvas显示的时候旋转 canvas 180度 是个好的解决方案
          const gradient = ctx.createLinearGradient(0, 0, 0, h);
          gradient.addColorStop(0, '#5DC045');
          gradient.addColorStop(0.29, '#5DC045');
          gradient.addColorStop(0.8, '#F1D737');
          gradient.addColorStop(1, '#F6445A');
          ctx.clearRect(0, 0, w, h);
          ctx.fillStyle = gradient;
          ctx.fillRect(0, 0, w, currentPercent * h);
        }
      }
    },
    changeItmeVal(val) {
      this.$refs.role.changeItmeVal(val);
    },
    reUseAudioWorklet() {
      // 重新加载AudioWorklet
      if (this.State.volumeBar) {
        this.State.volumeBar.destroyVolumeNode();
        const localAudioTrack = this.singChannel.audioTrack;
        if (localAudioTrack) {
          try {
            this.State.volumeBar.addAudioTrack(this.singChannel.id, localAudioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
              const dbLeftVal = 20 * Math.log10(volumeLeft * 16);
              const dbRightVal = 20 * Math.log10(volumeRight * 16);
              const ampLeft = Math.max(dbLeftVal / 60 + 0.8, 0);
              const ampRight = Math.max(dbRightVal / 60 + 0.8, 0);
              this.level = ampLeft;
              if (!this.anywhereSetting && !this.fullScreen && this.isAudioLevel && this.showTitle && !this.singChannel.leave) {
                this.canvasDrap(this.singChannel.id + 'Left', ampLeft);
                this.canvasDrap(this.singChannel.id + 'Right', ampRight);
              }
            });
          } catch (error) {
            console.log('error:', error);
          }
        }
      }
    },
    controlPrivate() {
      // if (this.returnPrivateStatus) return
      const localPrivateInfo = this.State.startPrivateInfo[this.userInfo.rtilCode];
      const type = localPrivateInfo && localPrivateInfo.includes(this.singChannel.id) ? 'cancelPrivateConversation' : 'startPrivateConversation';
      this.$emit('callback', {
        type,
        rtilCode: this.singChannel.id,
        channel: this.singChannel.channel
      });
    },
    setSpeakerAttendUser() {
      var _this$singChannel$aud, _this$singChannel$aud2;
      if (handleLocalStorage('get', 'speakerId')) (_this$singChannel$aud = this.singChannel.audioTrack) === null || _this$singChannel$aud === void 0 ? void 0 : (_this$singChannel$aud2 = _this$singChannel$aud.setPlaybackDevice) === null || _this$singChannel$aud2 === void 0 ? void 0 : _this$singChannel$aud2.call(_this$singChannel$aud, handleLocalStorage('get', 'speakerId'));
    },
    dealAudioMatrix(A, B) {
      return {
        left: A[0] * B[0],
        right: A[1] * B[1]
      };
    },
    changeFullRotate(val) {
      this.fullRotate = val;
    },
    updateTag(e) {
      this.setTag = e;
      this.$emit('updateList', e);
    },
    changeDevice(info) {
      this.$emit('callback', {
        type: 'changeParticipantMedia',
        val: info,
        id: this.singChannel.id
      });
    },
    dealVideoWidth() {
      this.showOperateDiv();
    },
    changeFullScreenVal(val) {
      var _this$$refs$videoCont;
      this.hasLeftDisplay = val;
      (_this$$refs$videoCont = this.$refs.videoControl) === null || _this$$refs$videoCont === void 0 ? void 0 : _this$$refs$videoCont.changeFullScreenVal(val);
    },
    changeFullScreen(val) {
      var _this$$refs$videoCont2;
      (_this$$refs$videoCont2 = this.$refs.videoControl) === null || _this$$refs$videoCont2 === void 0 ? void 0 : _this$$refs$videoCont2.fullScreen(val);
    },
    setMainwindow(type) {
      this.$emit('callback', {
        type: type == 'cancelMainWindow' ? 'unMainwindow' : 'mainwindow',
        id: this.singChannel.id
      });
      this.showUpinMainwindow = false;
    },
    operateCallback(obj) {
      const {
        type
      } = obj;
      if (type === 'fullScreen') {
        this.fullScreen = true;
        this.$refs.videoControl && this.$refs.videoControl.changeIsFullScreenVal(true);
        this.$emit('callback', {
          type: 'fullScreen',
          val: true,
          id: this.singChannel.id
        });
      } else {
        this.$emit('callback', obj);
      }
    },
    controlCallback(info) {
      const {
        type,
        val
      } = info;
      if (type === 'fullScreen') {
        if (this.useOldFullScreen) {
          if (val) {
            this.$refs.videoCon.requestFullscreen();
          } else {
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
              document.exitFullscreen();
            }
          }
          return;
        }
        if (val) {
          this.fullScreen = true;
        } else {
          this.fullScreen = false;
          if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
            document.exitFullscreen();
          }
        }
        this.$emit('callback', {
          type: 'fullScreen',
          val,
          id: this.singChannel.id
        });
      } else if (type == 'switchFullScreen') {
        this.hasLeftDisplay = val;
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
          document.exitFullscreen();
        }
        this.$emit('callback', info);
      } else if (type == 'setMute') {
        this.sourceMute = val;
      } else if (type === 'mouseMove') {
        document.addEventListener('mousemove', this.changeControlsStatus);
      } else if (type === 'removeMouseMove') {
        document.removeEventListener('mousemove', this.changeControlsStatus, false);
        if (this.controlOperateTimer) {
          clearTimeout(this.controlOperateTimer);
        }
      }
    },
    setVideoAndAudio(type, val) {
      if (this.singChannel.id == this.userInfo.rtilCode || this.userInfo.managerRtils.includes(this.userInfo.rtilCode)) {
        // 防止快速点击
        const timeStamp = Date.now();
        if (type === 'muteAudio') {
          if (timeStamp - this.lastAudioOperationTime < 1000) {
            if (this.initAudioPopup) {
              this.initAudioPopup = !this.initAudioPopup;
              this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
            }
            return;
          } else {
            this.initAudioPopup = true;
          }
        }
        if (type === 'muteVideo') {
          if (timeStamp - this.lastVideoOperationTime < 1000) {
            if (this.initVideoPopup) {
              this.initVideoPopup = !this.initVideoPopup;
              this.$message.warning(this.$t('commonFunction.notOperateFrequery'));
            }
            return;
          } else {
            this.initVideoPopup = true;
          }
        }
        if (type === 'muteAudio') {
          this.lastAudioOperationTime = timeStamp;
        }
        if (type === 'muteVideo') {
          this.lastVideoOperationTime = timeStamp;
        }
        this.$emit('callback', {
          type,
          id: this.singChannel.id,
          val
        });
      }
    },
    editName(str) {
      this.showEditInput = true;
      this.name = this.nickName || this.title;
      this.redTip = '';
    },
    saveName() {
      // if (!this.name.replace(/(^\s*)|(\s*$)/g, '')) {
      //   this.showEditInput = false
      //   return
      // }
      if (this.nameAjax || !this.singChannel.id || !this.name) return;
      this.nameAjax = true;
      const params = {
        senderRtilCode: this.userInfo.rtilCode,
        toRtilCode: this.singChannel.id,
        nickName: this.name,
        partyCode: this.State.partyCode
      };
      changeNickname(params, res => {
        if (res.data.errorCode === '0x0') {
          this.showEditInput = false;
          if (this.userInfo.rtilCode != this.singChannel.id) {
            // host 更改与会者的名字
            this.$message.success(this.$t('startNewParty.participantNameSuccessful'));
          } else {
            this.$message.success(this.$t('kioskHost.renameSuccessful'));
          }
        } else {
          this.redTip = res.data.errorCode;
        }
      });
      this.nameAjax = false;
    },
    checkAll(obj, val) {
      const info = {
        pipInfo: obj,
        type: 'switchFullScreen',
        val
      };
      this.$emit('callback', info);
    },
    getRemoteNetWorkIconColor(remoteNetWorkIconColor) {
      this.remoteNetWorkIconColor = remoteNetWorkIconColor;
    },
    showOperateDiv() {
      // 需要计算当前父盒子的宽度如果太小则不显示 icon, liveR 的下拉列表也在展开式时才显示
      if (this.$refs.videoTest) {
        const parentWidth = this.$refs.videoTest.clientWidth;
        if (parentWidth == 0) return;
        if (parentWidth < 166 && !this.showVideoBottom && !this.isRotated) {
          this.showDiv = false;
        } else {
          this.showDiv = true;
        }
      }
    },
    controlUpDown() {
      this.showVideoBottom = !this.showVideoBottom;
      const parentWidth = this.$refs.videoTest.clientWidth;
      // 只有当父盒子宽度较小的时候才去执行
      if (parentWidth < 166) {
        this.showVideoBottom ? this.showDiv = true : this.showDiv = false;
      }
    },
    changeControlsStatus() {
      this.isMouseMove = true;
      if (this.$refs.videoControl && !this.$refs.videoControl.showOperate) {
        this.$refs.videoControl.showOperate = true;
      }
      if (this.controlOperateTimer) {
        clearTimeout(this.controlOperateTimer);
      }
      this.controlOperateTimer = setTimeout(() => {
        this.isMouseMove = false;
        if (this.$refs.videoControl && this.$refs.videoControl.showOperate) {
          this.$refs.videoControl.showOperate = false;
        }
      }, 5000);
    }
  },
  watch: {
    outputRtilCode: {
      handler: function (val) {
        if (val) {
          this.hasLeftDisplay = val == this.singChannel.id;
        }
      },
      immediate: true
    },
    fullScreen: {
      handler: function (val) {
        if (val) {
          this.fullRotate = true;
          if (document.getElementById('pro_nav_icon')) {
            document.getElementById('pro_nav_icon').style.display = 'none';
          }
        } else {
          this.fullRotate = false;
          if (document.getElementById('pro_nav_icon')) {
            document.getElementById('pro_nav_icon').style.display = 'block';
          }
        }
      }
    },
    name(val) {
      this.name = this.name.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
    },
    fullScreenInfo(newVal, oldVal) {
      if (!newVal && oldVal) this.fullScreen = false;
    },
    showEditInput(val) {
      if (val) {
        this.$nextTick(() => {
          // 自动获取焦点 element组件autofocus失效
          this.$refs.name.$refs.input.focus();
          this.$refs.name.$refs.input.select();
        });
      }
    },
    isMute(val) {
      if (!this.singChannel.id || !this.singChannel.audioTrack) return;
      if (this.controlMute !== '') {
        if (this.controlMute) {
          this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
        } else {
          this.rtc.play && this.rtc.play(this.singChannel.audioTrack, '', {
            type: 'audio'
          });
        }
      } else {
        if (this.showPrivateBg) {
          this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
        } else {
          if (this.isMute) {
            this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
          } else {
            // commom party模式不需要听见host自己的声音
            if ((this.$route.name === 'party' || this.$route.name === 'partyParticipate') && this.userInfo.rtilCode == this.singChannel.id) {
              return;
            }
            if (this.rtc && this.rtc.play) {
              this.rtc.play(this.singChannel.audioTrack, '', {
                type: 'audio'
              });
            }
          }
        }
      }
    },
    controlMute(val) {
      if (this.singChannel.audioTrack) {
        if (this.controlMute !== '') {
          if (this.controlMute) {
            this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
          } else {
            this.rtc.play && this.rtc.play(this.singChannel.audioTrack, '', {
              type: 'audio'
            });
          }
        } else {
          if (this.isMute) {
            this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
          } else {
            if (this.singChannel.id != this.userInfo.rtilCode) {
              this.rtc.play(this.singChannel.audioTrack, '', {
                type: 'audio'
              });
            }
          }
        }
      }
    },
    singChannel: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue || newValue && JSON.stringify(newValue) == '{}') {
          return;
        }
        this.$nextTick(() => {
          // 过滤掉本地的audio进行speaker的初始化
          if (this.singChannel.audioTrack && this.userInfo.rtilCode != newValue.id) {
            this.setSpeakerAttendUser();
          }
          const localAudioTrack = newValue.audioTrack;
          if (newValue.id == this.userInfo.rtilCode && localAudioTrack && localAudioTrack._mediaStreamTrack) {
            try {
              var _this$State$volumeBar;
              (_this$State$volumeBar = this.State.volumeBar) === null || _this$State$volumeBar === void 0 ? void 0 : _this$State$volumeBar.addAudioTrack(newValue.id, localAudioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
                const dbLeftVal = 20 * Math.log10(volumeLeft * 16);
                const dbRightVal = 20 * Math.log10(volumeRight * 16);
                const ampLeft = Math.max(dbLeftVal / 60 + 0.8, 0);
                const ampRight = Math.max(dbRightVal / 60 + 0.8, 0);
                this.level = ampLeft;
                this.$emit('callback', {
                  type: 'audioContext',
                  val: this.level
                });
                if (!this.anywhereSetting && !this.fullScreen && this.isAudioLevel && this.showTitle && !this.singChannel.leave) {
                  this.canvasDrap(this.singChannel.id + 'Left', ampLeft);
                  this.canvasDrap(this.singChannel.id + 'Right', ampRight);
                }
              });
            } catch (error) {
              console.log('destroyAudioContext error:', error);
            }
          }
          if ((JSON.stringify(newValue) === '{}' || !newValue.id) && !newValue.clearVideo) return;
          if (this.userInfo.rtilCode == newValue.id && !newValue.showLocal && this.outputRtilCode != this.userInfo.rtilCode) return;
          // 走了
          if (newValue.videoTrack) {
            let palyerConfig = '';
            if (newValue.shareCode == newValue.id || newValue.id == this.outputRtilCode) {
              palyerConfig = {
                fit: 'contain'
              };
            }
            this.rtc && this.rtc.play && this.rtc.play(newValue.videoTrack, palyerConfig, {
              videoBox: this.$refs.videoTest,
              type: 'video'
            }, () => {
              this.loadVideoTrack = true;
              this.$refs.videoControl && this.$refs.videoControl.calculateBoxWidth();
            });
          }
          if (oldValue && oldValue.audioTrack && !this.State.commonHostLeftRight) {
            this.rtc.stop && this.rtc.stop(oldValue.audioTrack);
          }
          this.showOperateDiv();
          // 判断如果当前是自己分享的视频则不播放
          if (newValue.shareInitiator == this.userInfo.rtilCode && newValue.shareCode) return;
          // 如果自己上大屏并且没开 audiofeedback 则不播放
          if (this.singChannel.id == this.userInfo.rtilCode && !this.hearSelf) return;
          if (newValue.audioTrack) {
            if (this.controlMute !== '') {
              if (this.controlMute) {
                this.rtc.stop && this.rtc.stop(newValue.audioTrack);
              } else {
                this.rtc.play && this.rtc.play(newValue.audioTrack, '', {
                  type: 'audio'
                });
              }
            } else {
              if (this.isMute || this.muteAudio) {
                this.rtc.stop && this.rtc.stop(newValue.audioTrack);
              } else {
                if (!this.State.startPrivateInfo[this.singChannel.id] || this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode)) {
                  this.rtc.play && this.rtc.play(newValue.audioTrack, '', {
                    type: 'audio'
                  });
                }
              }
            }
          }
          if (newValue.audioTrack) {
            // 改用新版本后每次对端禁用麦克风在打开都会是一个新的track
            if (!this.isMute && !this.muteAudio) {
              // 有私聊判断是否是私聊的与会者
              if (this.privateInfo.rtilCode) {
                if (this.userInfo.rtilCode != this.privateInfo.rtilCode && this.userInfo.rtilCode != this.privateInfo.crewRtilCode) {
                  if (this.singChannel.id != this.privateInfo.rtilCode && this.singChannel.id != this.privateInfo.crewRtilCode) {
                    this.rtc.play && this.rtc.play(newValue.audioTrack, '', {
                      type: 'audio'
                    });
                  } else {
                    this.rtc.stop && this.rtc.stop(newValue.audioTrack);
                  }
                }
              } else {
                if (this.userInfo.rtilCode != newValue.id && !this.controlMute) {
                  if (!this.State.startPrivateInfo[this.singChannel.id] || this.State.startPrivateInfo[this.singChannel.id].includes(this.userInfo.rtilCode)) {
                    this.rtc.play && this.rtc.play(newValue.audioTrack, '', {
                      type: 'audio'
                    });
                  }
                  if (newValue.id == this.userInfo.rtilCode && this.muteAudio) {
                    this.rtc.stop(newValue.audioTrack);
                  }
                  if (this.$route.name == 'party') {
                    if (this.sourceMute) {
                      this.$refs.videoControl && this.$refs.videoControl.changeVideoVolume(0);
                    }
                  }
                }
              }
            }
            if (localAudioTrack && localAudioTrack._mediaStreamTrack) {
              try {
                var _this$State$volumeBar2;
                (_this$State$volumeBar2 = this.State.volumeBar) === null || _this$State$volumeBar2 === void 0 ? void 0 : _this$State$volumeBar2.addAudioTrack(newValue.id, localAudioTrack._mediaStreamTrack, (volumeLeft, volumeRight) => {
                  const dbLeftVal = 20 * Math.log10(volumeLeft * 16);
                  const dbRightVal = 20 * Math.log10(volumeRight * 16);
                  const ampLeft = Math.max(dbLeftVal / 60 + 0.8, 0);
                  const ampRight = Math.max(dbRightVal / 60 + 0.8, 0);
                  this.level = ampLeft;
                  if (!this.anywhereSetting && !this.fullScreen && this.isAudioLevel && this.showTitle && !this.singChannel.leave) {
                    this.canvasDrap(this.singChannel.id + 'Left', ampLeft);
                    this.canvasDrap(this.singChannel.id + 'Right', ampRight);
                  }
                });
              } catch (error) {
                console.log('volumeBar addAudioTrack error:', error);
              }
            }
          }
          // 为了 Common party pushtalk 加的
          if (this.userInfo.channelMode == 0 && JSON.stringify(this.State.currentPushTalkInfo) != '{}') {
            Object.keys(this.State.currentPushTalkInfo).forEach(groupId => {
              const {
                rtilCodeList,
                talk,
                startRtilCode
              } = this.State.currentPushTalkInfo[groupId];
              if (talk) {
                if (!rtilCodeList.includes(this.userInfo.rtilCode) && this.singChannel.id == startRtilCode) {
                  console.log('stop play audiotrack ', startRtilCode);
                  this.rtc && this.rtc.stop(this.singChannel.audioTrack);
                }
              } else {
                if (this.singChannel.id == startRtilCode && startRtilCode != this.userInfo.rtilCode) {
                  console.log('start play audiotrack ', startRtilCode);
                  this.rtc && this.rtc.play(this.singChannel.audioTrack, '', {
                    type: 'audio'
                  });
                }
              }
            });
          }
        });
      }
    },
    privateInfo: {
      deep: true,
      handler(val) {
        const userRtilCode = this.State.currentRtilCode;
        if (JSON.stringify(val) != '{}') {
          // 根据私聊信息去改变正在私聊的两个人的vfb声音
          if (userRtilCode == val.crewRtilCode || userRtilCode == val.rtilCode) {
            this.privateInfoForVolume = val;
          }
        } else {
          if (this.outputRtilCode && (this.privateInfoForVolume.crewRtilCode == userRtilCode || userRtilCode == this.privateInfoForVolume.rtilCode)) {
            this.privateInfoForVolume = {};
          }
        }
      }
    },
    muteAudio(val) {
      if (this.isMute || this.controlMute) return;
      if (this.showPrivateBg && !val) return;
      if (this.singChannel.audioTrack) {
        if (val) {
          this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
        } else {
          if (this.singChannel.id != this.userInfo.rtilCode) {
            this.rtc.play(this.singChannel.audioTrack, '', {
              type: 'audio'
            });
          }
        }
      }
    },
    muteVideo(val) {
      this.hideVideoBg = val;
    },
    needStartVoip(val) {
      if (val) {
        this.Webrtc.init(this.State.config.urlInfo.webRtc, this.sourceId ? {
          loginName: this.sourceId
        } : '', () => {
          var _this$$refs$voip2;
          (_this$$refs$voip2 = this.$refs.voip) === null || _this$$refs$voip2 === void 0 ? void 0 : _this$$refs$voip2.startVoIP();
        });
      }
    },
    'State.currentPushTalkInfo': {
      handler: function (info) {
        if (!this.singChannel.audioTrack) return;
        console.log('log: ', info, this.singChannel.id);
        Object.keys(info).forEach(groupName => {
          const {
            rtilCodeList,
            talk,
            startRtilCode
          } = info[groupName];
          if (talk) {
            if (!rtilCodeList.includes(this.userInfo.rtilCode) && this.singChannel.id == startRtilCode) {
              console.log('stop play audiotrack ', startRtilCode);
              this.rtc && this.rtc.stop(this.singChannel.audioTrack);
            }
          } else {
            if (this.singChannel.id == startRtilCode && startRtilCode != this.userInfo.rtilCode) {
              console.log('start play audiotrack ', startRtilCode);
              this.rtc && this.rtc.play(this.singChannel.audioTrack, '', {
                type: 'audio'
              });
            }
          }
        });
      },
      deep: true
    }
  },
  mounted() {
    const _this = this;
    this.$nextTick(() => {
      // 添加双击事件绑定
      this.$refs.videoCon.addEventListener('dblclick', () => {
        if (this.userInfo.channelMode == 0 && (this.userInfo.owner || this.State.currentPartyInfo.coHost == 2)) {
          this.$emit('callback', {
            type: 'dobuleClick',
            val: true,
            id: this.singChannel.id
          });
        }
      });
      // 添加判断是 pgm 还是普通与会者
      if (!this.isMute && !this.muteAudio && this.outputRtilCode == this.singChannel.id) {
        _this.$refs.videoControl && _this.$refs.videoControl.changeVideoVolume(this.pipVolume);
      }
      if (this.singChannel.audioTrack) {
        // 判断如果当前是自己分享的视频则不播放
        try {
          if (this.singChannel.shareInitiator == this.userInfo.rtilCode && this.singChannel.shareCode) {
            return;
          }
          if (this.singChannel.id == this.userInfo.rtilCode && !this.hearSelf) {
            return;
          }
        } catch (error) {
          console.log('error: ', error);
        }
        if (this.controlMute !== '') {
          if (this.controlMute) {
            this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
          } else {
            this.rtc.play && this.rtc.play(this.singChannel.audioTrack, '', {
              type: 'audio'
            });
          }
        } else {
          if (this.isMute || this.muteAudio) {
            this.rtc.stop && this.rtc.stop(this.singChannel.audioTrack);
          } else {
            this.rtc.play && this.rtc.play(this.singChannel.audioTrack, '', {
              type: 'audio'
            });
          }
        }
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.dealVideoWidth);
    if (this.controlOperateTimer) {
      clearTimeout(this.controlOperateTimer);
    }
    if (this.State.volumeBar) this.State.volumeBar.destroyVolumeNode(this.singChannel.id);
  }
};